<template>
    <b-container fluid>
        <b-row>
            <b-col md="6" class="pt-3">
                <b-row>
                    <b-col cols="auto" class="mr-auto"><h4>{{ areMyPortal ? 'My Portals' : 'Portal List' }}</h4></b-col>
                    <b-col cols="auto">
                        <b-link :to="{ name: 'ConfNewPortal', params: { isNewPortal: true } }"
                                class="h4 text-primary mr-2" v-b-tooltip.hover title="Create portal">
                            <b-icon icon="plus-circle"></b-icon>
                        </b-link>
                        <b-link @click="showImportModal" class="h4 text-primary" v-b-tooltip.hover
                                title="Import portal">
                            <b-icon icon="box-arrow-in-left"></b-icon>
                        </b-link>
                    </b-col>
                </b-row>
                <b-row class="sticky pt-3 pb-3" v-if="!areMyPortal" style="background: #fff">
                    <b-col md="8">
                        <b-input-group>
                            <b-form-input placeholder="Search by name" v-model="name" @input="searchName"></b-form-input>
                            <b-input-group-append>
                                <b-button squared variant="outline-secondary" @click="searchName">Search</b-button>
                                <b-button squared variant="outline-primary" @click="getPortals">All</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col md="4" align-self="center" class="text-right">
                        <b-form-checkbox-group v-model="filters" :options="optionsFilters" switches></b-form-checkbox-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="fill"
                            aria-controls="my-portals"
                        ></b-pagination>

                        <b-list-group id="my-portals" v-if="portals != null">
                            <b-list-group-item class="text-center" v-if="portals.length === 0">
                                No portal found
                            </b-list-group-item>
                            <b-list-group-item button v-for="(portal, index) in portalsForList"
                                               :key="index"
                                               :active="index === currentIndex"
                                               @click="setActivePortal(portal, index)"
                                               class="d-flex align-items-center">
                                <b-avatar :text="portal.client.shortName"
                                          :variant="portal.client.color.startsWith('#') ? '' : portal.client.color"
                                          :style="portal.client.color.startsWith('#') ? `color: #fff; background: ${portal.client.color}` : ''"
                                          class="mr-3"></b-avatar>
                                <span class="mr-auto">
                                    {{ portal.name }}
                                    <small><b-badge v-if="portal.leadSpace" variant="primary" class="ml-3">Deal</b-badge></small>
                                </span>
                                <small>{{ portal.client.name }}
                                    <b-badge v-if="portal.disabled" variant="secondary" class="ml-3">Disabled</b-badge>
                                    <b-badge v-if="!portal.disabled && portal.published" variant="success" class="ml-3">Enabled</b-badge>
                                    <b-badge v-if="!portal.disabled && !portal.published" variant="warning" class="ml-3" style="color: white">Draft</b-badge>
                                </small>
                            </b-list-group-item>
                        </b-list-group>
                        <div v-if="portals == null" class="text-center">
                            <b-spinner label="Spinning"></b-spinner>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="6">
                <div v-if="currentPortal" class="sticky pt-3">
                    <b-row class="mb-2">
                        <b-col md="6">
                            <span class="align-middle"><b-iconstack font-scale="1.5" class="h-100">
                                <b-icon stacked icon="circle-fill"
                                        :variant="currentPortal.disabled ? 'secondary' : currentPortal.published ? 'success' : 'warning'"></b-icon>
                                <b-icon stacked icon="power" scale="0.5" variant="white"></b-icon>
                            </b-iconstack></span>
                            <span class="h4 align-middle">
                                Portal</span>
                        </b-col>

                        <b-col md="6" class="text-right">
                            <b-dropdown id="portal-dropdown" split right split-variant="outline-primary"
                                        variant="primary"
                                        :split-to="{ name: currentPortal.published ? 'PortalSubmission' : 'DraftSubmission', params: { name: currentPortal.name } }">
                                <template v-slot:button-content>
                                    <b-icon icon="eye-fill"></b-icon>
                                    Show
                                </template>
                                <b-dropdown-item
                                    :to="{ name: 'ConfNewPortal', params: { isNewPortal: true, isDuplicate: true, id: currentPortal.id } }">
                                    <b-icon icon="files"></b-icon>
                                    Duplicate
                                </b-dropdown-item>
                                <b-dropdown-item-button @click="clearPortalCache(currentPortal.name)">
                                    <b-icon icon="arrow-repeat"></b-icon>
                                    Clear cache
                                </b-dropdown-item-button>
                                <b-dropdown-item @click="showExportModal">
                                    <b-icon icon="box-arrow-right"></b-icon>
                                    Export
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" class="mb-2">
                            <div>
                                <label><strong>Name:</strong></label> {{ currentPortal.name }}
                            </div>
                            <div>
                                <label><strong>Client:</strong></label>
                                {{ currentPortal.client != null ? currentPortal.client.name : "" }}
                            </div>
                        </b-col>

                        <b-col md="12" class="text-center">
                            <b-button-group>
                                <b-button squared variant="primary" class="mr-2"
                                          :to="{ name: 'ConfPortal', params: { name: currentPortal.name } }">
                                    <b-icon icon="info-circle"></b-icon>
                                    Detail
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                </div>
            </b-col>
        </b-row>

        <b-modal id="modal-export" title="Export portal configuration" @ok="exportPortal($event, currentPortal.name)"
                 ok-title="Export" :ok-disabled="exportModal.loading" :cancel-disabled="exportModal.loading">
            <b-overlay :show="exportModal.loading">
                <b-form-group label="Export file name" label-for="export-fileName">
                    <b-input-group append=".json">
                        <b-form-input id="export-fileName" name="export-fileName"
                                      v-model="exportModal.fileName"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-checkbox id="ckc-export-client" name="ckc-export-client" v-model="exportModal.withClient">
                    With client configuration
                </b-form-checkbox>
            </b-overlay>
        </b-modal>

        <b-modal id="modal-import" title="Import portal configuration" @ok="importPortal" size="lg"
                 ok-title="Import" :ok-disabled="importModal.loading || !importModal.portal"
                 :cancel-disabled="importModal.loading">
            <b-overlay :show="importModal.loading">
                <b-form-group label="Import file" label-for="export-fileName">
                    <b-input-group>
                        <b-form-file v-model="importModal.file" accept=".json"
                                     placeholder="Select a portal json file or drop it here..."
                                     drop-placeholder="Drop file here..."/>
                        <b-input-group-append v-if="importModal.file">
                            <b-button @click="importLoadFile" variant="primary">Load</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <div v-if="importModal.portal">
                    <b-form-group label="Client" label-for="client" class="required">
                        <b-form-input v-if="importModal.withClient" id="client" name="client"
                                      v-model="importModal.portal.client.name"/>
                        <b-form-select v-if="!importModal.withClient" id="client" name="client"
                                       v-model="importModal.portal.client" class="required"
                                       v-validate="'required'" :state="validateState('client')">
                            <b-form-select-option v-for="selectClient in importModal.clients"
                                                  :key="selectClient.id"
                                                  :value="selectClient">
                                {{ selectClient.name }}
                            </b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback id="clientFeedback'">
                            Client is required.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Portal name" label-for="import-portal-name" class="required">
                        <b-form-input id="import-portal-name" name="import-portal-name"
                                      v-model="importModal.portal.name" :formatter="stringFormatter"
                                      v-validate="'required'" :state="validateState('portalName')"></b-form-input>
                        <b-form-invalid-feedback id="portalFeedback'">
                            Portal name is required.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>
            </b-overlay>
        </b-modal>

    </b-container>
</template>

<script>
    import PortalDataService from "@/services/PortalDataService";
    import CacheService from "@/services/CacheService";
    import StringUtils from "@/services/utils/StringUtils";
    import ClientDataService from "@/services/ClientDataService";

    export default {
        name: "PortalList",
        mixins: [StringUtils],
        created() {
            document.title = "Configuration : Portals";
        },
        props: {
            areMyPortal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                portals: null,
                perPage: 10,
                currentPage: 1,
                currentPortal: null,
                currentIndex: -1,
                name: "",
                filters: [],
                optionsFilters: [
                    { text: 'Classic', value: 'partner' },
                    { text: 'Deal', value: 'ls' },
                ],
                exportModal: {
                    loading: false,
                    fileName: '',
                    withClient: false,
                },
                importModal: {
                    loading: false,
                    file: null,
                    portal: null,
                    withClient: false,
                    clients: null
                }
            }
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            },
            rows() {
                return this.portals ? this.portals.length : 0;
            },
            filteredPortals() {
                if (this.filters.length === 0 || (this.filters.includes("ls") && this.filters.includes("partner"))) {
                    return this.portals;
                }
                let lsFilter;
                if (this.filters.includes("ls") && !this.filters.includes("partner")) {
                    lsFilter = true;
                }
                if (!this.filters.includes("ls") && this.filters.includes("partner")) {
                    lsFilter = false;
                }
                return this.portals.filter(p => p.leadSpace === lsFilter);
            },
            portalsForList() {
                if (this.filteredPortals) {
                    return this.filteredPortals.slice(
                        (this.currentPage - 1) * this.perPage,
                        this.currentPage * this.perPage,
                    );
                } else {
                    return null;
                }
            }
        },
        mounted() {
            this.getPortals();
        },
        methods: {
            getPortals() {
                if (this.areMyPortal) {
                    PortalDataService.findByManager(this.currentUser.email)
                        .then(response => (this.portals = response.data))
                        .catch(error => console.log(error))
                } else {
                    PortalDataService.getAll()
                        .then(response => (this.portals = response.data))
                        .catch(error => console.log(error))
                }
            },
            setActivePortal(portal, index) {
                this.currentPortal = portal;
                this.currentIndex = index;
            },
            clearPortalCache(name) {
                this.$bvModal.msgBoxConfirm('Are you sure you want to refresh the portal cache ?', {
                    title: 'Please Confirm',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    hideHeaderClose: false,
                })
                    .then(value => {
                        if (value) {
                            this.$bvModal.show('loading-modal');
                            CacheService.clearPortal(name, true)
                                .then(response => {
                                    console.log(response);
                                    this.$parent.displaySuccessMessage('The cache was deleted cleared.');
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.$parent.displayErrorMessage('An error occurred while trying to clear the cache.');
                                });
                        }
                    })
                    .catch(error => console.log(error));
            },
            searchName() {
                PortalDataService.findByName(this.name)
                    .then(response => (this.portals = response.data))
                    .catch(error => console.log(error))
            },
            showExportModal() {
                this.exportModal.loading = false;
                this.exportModal.fileName = 'portal-export-' + this.currentPortal.name;
                this.$root.$emit('bv::show::modal', 'modal-export')
            },
            exportPortal(event, name) {
                event.preventDefault();
                this.exportModal.loading = true;
                PortalDataService.export(name, this.exportModal.withClient)
                    .then(response => {
                        this.downloadString(JSON.stringify(response.data), "text/json", this.exportModal.fileName + ".json")
                        this.$nextTick(() => {
                            this.$bvModal.hide('modal-export')
                            this.exportModal.loading = false;
                        })
                    })
                    .catch(error => console.log(error))
            },
            showImportModal() {
                this.importModal.loading = false;
                this.importModal.portal = null;
                if (this.importModal.clients == null) {
                    ClientDataService.getAll()
                        .then(response => {
                            this.importModal.clients = response.data;
                            this.$root.$emit('bv::show::modal', 'modal-import')
                        })
                        .catch(error => console.log(error))
                } else {
                    this.$root.$emit('bv::show::modal', 'modal-import')
                }
            },
            importLoadFile() {
                const reader = new FileReader();
                reader.onload = event => {
                    this.importModal.portal = JSON.parse(event.target.result);
                    if (this.importModal.portal.client) {
                        this.importModal.withClient = true;
                    } else {
                        this.importModal.withClient = false;
                    }
                };
                reader.readAsText(this.importModal.file);
            },
            importPortal(event) {
                event.preventDefault();
                this.importModal.loading = true;
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        PortalDataService.create(this.importModal.portal)
                            .then(response => {
                                this.$parent.displaySuccessMessage('The portal was imported successfully.');
                                this.$router.push({name: "ConfPortal", params: {name: response.data.name}});
                                this.importModal.loading = false;
                            })
                            .catch(error => {
                                console.log(error);
                                this.importModal.loading = false;
                                this.$parent.displayErrorMessage('An error occurred while trying to import the portal.');
                            });
                    } else {
                        this.importModal.loading = false;
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return this.veeErrors.has(ref) ? !this.veeErrors.has(ref) : null;
                }
                return null;
            },
        },
        updated: function () {
            this.$nextTick(function () {
                var dropdown = document.getElementById('portal-dropdown');
                if (dropdown) {
                    dropdown.getElementsByTagName("a").item(0).target = "_blank";
                }
            })
        }
    }
</script>

<style scoped>
    .sticky {
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 999;
    }
</style>